var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstructorToolBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0037 25.3959L18.3867 40.4899V26.0879L43.0037 12.9419V25.3959Z",
    fill: "#172535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0041 12.9678L18.3871 26.2328L4.99414 18.8758L29.6891 7.50977L43.0041 12.9678Z",
    fill: "#FD6A3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3871 26.088V40.49L4.99414 32.296V18.876",
    fill: "#FD6A3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3863 26.0878V39.9488L5.57031 31.7188V19.2148",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2129 18.7397V15.1417L27.2589 10.8447L28.7849 11.6607",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2129 15.1426V18.7376L20.7389 19.5556V15.9576L19.2129 15.1426Z",
    fill: "#172535"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0527 15.6199L26.5777 16.4379V13.7559L25.0527 15.6199Z",
    fill: "#F2F2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9443 18.3726L20.7383 19.5556V15.9576L28.7843 11.6606V15.2546L26.5783 16.4366V14.9066L22.9443 16.8466V18.3726Z",
    fill: "#172535"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0996 26.7406V24.7446L32.2106 23.0396L33.7366 23.8556",
    fill: "#FD6A3C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0996 24.7456V26.7386L30.6246 27.5556V25.5606L29.0996 24.7456Z",
    fill: "#F2F2F2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.737 23.8555L30.625 25.5605V27.5565L33.737 25.8475V23.8555Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructorToolBox);
export default __webpack_public_path__ + "static/media/instructorToolBox.8378f1e1addd39e91c2c0a821ae276f9.svg";
export { ForwardRef as ReactComponent };